import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {CognitoUtil} from './cognito.service';
import {environment} from '../../environments/environment';

@Injectable()
export class ReportingLeaderboardService {

  constructor(private http: HttpClient, public cognitoUtil: CognitoUtil) {

  }

  public getMonthlyTeamMembersParticipationStats(month: number, year: number, limit: number, offset: number, isSortDsc: boolean) {

    const url = `${environment.apiRoot}/reporting/leaderboard/${month}/${year}?limit=${limit}&offset=${offset}&isSortDsc=${isSortDsc}`;
    const myThis = this;

    return new Promise((resolve, reject) => {
      let httpHeaders = new HttpHeaders();
      httpHeaders = httpHeaders
        .set('Content-Type', 'application/json');

      myThis.http.get(url, {headers: httpHeaders})
        .subscribe(
          (data: any) => {
            resolve(data.data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getMonthlyTeamMembersParticipationStatsDownloadAsCsv(month: number, year: number) {

    const url = `${environment.apiRoot}/reporting/leaderboard/download-as-csv/${month}/${year}`;
    const myThis = this;

    return new Promise((resolve, reject) => {
      let httpHeaders = new HttpHeaders();
      httpHeaders = httpHeaders
        .set('Content-Type', 'application/json');

      myThis.http.get(url, {headers: httpHeaders})
        .subscribe(
          (data: any) => {
            resolve(data.data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
}
